module.exports = __webpack_public_path__ + "img/flag_australia.bc936a8c.svg";